import artists from '../../services/routes/artists/artists';

const state = {
    all: [],
    artists: {}
};

const getters = {
    artists: state => state.artists
};

const actions = {
    fetchArtists({ commit }) {
        artists.onboarding().then(artists => {
            commit('setArtists', artists.data)
        })
    },
};

// mutations
const mutations = {
    setArtists (state, artists) {
        state.all = artists
    },
    all(state, artists) {
        state.artists = artists
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
